import React, { useEffect, useRef } from 'react';

import debounce from '../../../utils/debounce';
import { type Key } from '../Table.types';

export interface MeasureCellProps {
    columnKey: Key;
    onColumnResize: (key: Key, width: number) => void;
}

const MeasureCell = ({ columnKey, onColumnResize }: MeasureCellProps) => {
    const cellRef = useRef<HTMLTableCellElement>(null);

    const resizeHandler = () => {
        if (cellRef.current) {
            onColumnResize(columnKey, cellRef.current.offsetWidth);
        }
    };

    const debounceResizeHandler = debounce(resizeHandler, 200);

    useEffect(() => {
        resizeHandler();
    }, []);

    useEffect(() => {
        const listObserver = new ResizeObserver(debounceResizeHandler);

        if (cellRef.current) {
            listObserver.observe(cellRef.current);
        }

        return () => {
            if (cellRef.current) {
                listObserver.unobserve(cellRef.current);
            }
        };
    }, [cellRef?.current]);

    return (
        <td ref={cellRef} style={{ padding: 0, border: 0, height: 0 }}>
            <div style={{ height: 0, overflow: 'hidden' }}>&nbsp;</div>
        </td>
    );
};

export default MeasureCell;
